(function () {
    "use strict";

    angular.module("app").factory("guid", GuidService);

    GuidService.$inject = ["uuid"];
    function GuidService(uuid) {
        return {
            // Use new function instead of v4 to hide which UUID version is used
            new: () => uuid.v4(),
            // REMARK: Naming follows uuid library naming which in turn is the successor of the node-uuid library used by us
            validate: isValidGuid,
            // With uuid this would simply be a strict comparison to uuid.NIL
            isEmpty: isEmptyGuid,
        };

        function isValidGuid(str) {
            // REMARK: This is not compliant with the RFC,
            // this will match some invalid UUIDs
            // It also will not match the empty or Max UUID
            // Regular expression to check if string is a valid UUID
            const regexExp = /^[0-9A-F]{8}\b-[0-9A-F]{4}\b-[0-9A-F]{4}\b-[0-9A-F]{4}\b-[0-9A-F]{12}$/gi;

            return regexExp.test(str);
        }

        function isEmptyGuid(str) {
            const NIL_UUID = '00000000-0000-0000-0000-000000000000';

            return str === NIL_UUID;
        }
    }
})();